"use client";

import { NetworkEndpoints } from "@/configs/NetworkEndpoints";
import { useAuth } from "@/features/auth/contexts/AuthContext";
import { useEffect, useRef, useState } from "react";

interface LeadInquiryData {
    phone: string;
    companyName: string;
}

export const useLatestLeadInquiry = (): {
    data: LeadInquiryData | null;
    isLoading: boolean;
} => {
    const { isAuthenticated, getToken } = useAuth();
    const [data, setData] = useState<LeadInquiryData | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!isAuthenticated || hasFetched.current) {
            setIsLoading(false);
            return;
        }

        const token = getToken();
        if (!token) {
            setIsLoading(false);
            return;
        }

        hasFetched.current = true;
        setIsLoading(true);

        fetch(`${NetworkEndpoints.leadInquiries()}?limit=1&offset=0`, {
            headers: { Authorization: token },
        })
            .then((res) => {
                if (!res.ok) return null;
                return res.json();
            })
            .then((json) => {
                if (json?.inquiries?.length > 0) {
                    const latest = json.inquiries[0];
                    setData({
                        phone: latest.phone,
                        companyName: latest.companyName,
                    });
                }
            })
            .catch(() => {
                // Silently fail — prefill is best-effort
            })
            .finally(() => setIsLoading(false));
    }, [isAuthenticated, getToken]);

    return { data, isLoading };
};
